import type { ReactNode } from "react";
import { LanguageToggle } from "@/components/LanguageToggle";
import { Panel } from "@/components/ui";
import { useT } from "@/lib/i18n";

export function AuthLayout({ children, title }: { children: ReactNode; title?: string }) {
  const t = useT();
  return (
    <div className="relative flex min-h-full flex-col items-center px-4 py-12">
      <LanguageToggle className="absolute right-4 top-4" />
      <div className="wordmark mb-2 text-5xl">.MAYUSCULANOTE</div>
      <p className="mb-10 text-muted">{t.tagline}</p>
      <Panel className="w-full max-w-md">
        {title ? <h1 className="display mb-5 text-2xl">.{title}</h1> : null}
        {children}
      </Panel>
    </div>
  );
}
